module.exports = __webpack_public_path__ + "img/adrs-logo.90a757ba.jpg";